import { DeepPartial } from "@towersystems/roam-common/lib/shared-types";
import { TxnType } from "../../types";
import { PosApiResponseWithResult } from "../pos-api-response-with-result";
import { PurchaseAnalysisData } from "../../constants";
import { ReceiptResponse } from "../receipt";

export class TransactionResponse extends PosApiResponseWithResult {
  constructor(input?: DeepPartial<TransactionResponse>) {
    super(input);
    // Re-apply after super(): subclass field declarations are emitted as field
    // initializers that reset every declared property to undefined once super()
    // returns (see babel @babel/plugin-transform-class-properties), wiping the
    // values BaseResponse copied. Re-assigning here, in the constructor body,
    // runs after that wipe and restores the API payload.
    if (input) {
      Object.assign(this, input);
    }
    if (!this.Receipts) {
      this.Receipts = [];
    }
  }

  public TxnType: TxnType;

  public Merchant: string;

  public CardType: string;

  public CardName: string;

  public RRN?: string;

  public DateTime: string;

  public DateSettlement: string;

  public AmtCash: number;

  public AmtPurchase: number;

  public AmtTip: number;

  public AuthCode: number;

  public TxnRef: string;

  public PAN: string;

  public DateExpiry: string;

  public Track2: string;

  public AccountType: string;

  public Receipts: ReceiptResponse[];

  // The pinpad returns PurchaseAnalysisData keys in varying casing (e.g. "Amt",
  // "Sur", "Rfn") after camelCase normalisation, which won't match the constant
  // keys ("AMT", "SUR", "RFN"). Look up case-insensitively so the value is found
  // regardless of casing.
  private getPurchaseAnalysisValue(key: string): string | undefined {
    const pad = this.PurchaseAnalysisData ?? {};
    const match = Object.keys(pad).find(
      (k) => k.toLowerCase() === key.toLowerCase()
    );
    return match ? pad[match] : undefined;
  }

  // If tipping or surcharging is enabled this should return the total transaction amount (in cents)
  // including tips and surcharges
  get AmountTotal(): number {
    const maybeValue = this.getPurchaseAnalysisValue(PurchaseAnalysisData.Amount);
    return maybeValue ? parseInt(maybeValue, 10) : this.AmtPurchase;
  }

  get Surcharge(): number | undefined {
    const maybeValue = this.getPurchaseAnalysisValue(
      PurchaseAnalysisData.Surcharge
    );
    return maybeValue ? parseInt(maybeValue, 10) : undefined;
  }

  get RFN(): string | undefined {
    return this.getPurchaseAnalysisValue(PurchaseAnalysisData.RFN);
  }
}
